// the values must match the named export

enum RoleIconName {
  StandardAdmin = 'iconStandardAdmin',
  Photographer = 'iconPhotographer',
  MeetManagerSwimming = 'iconMeetManagerSwimming',
  MeetManagerTrackAndField = 'iconMeetManagerTrackAndField',
  TournamentDirector = 'iconTournamentDirector',
  AssociationAdmin = 'iconAssociationAdmin',
  StatSupplier = 'iconStatSupplier',
  Writer = 'iconWriter'
}

export default RoleIconName;
